import { useState, useEffect } from 'react';
import { m } from 'framer-motion';
import Logo from './Logo';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 72);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-surface/95 backdrop-blur-md' : ''
      }`}
      aria-label="Primary navigation"
    >
      <m.div
        className="absolute bottom-0 inset-x-0 h-px bg-ink/[0.07]"
        style={{ originX: 0 }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: scrolled ? 1 : 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-5 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2.5 group" aria-label="Vehi Systems home">
          <Logo size={26} invert={!scrolled} />
          <span
            className={`font-semibold text-[1.05rem] -mb-1 tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-ink' : 'text-white'
            }`}
          >
            Vehi Systems
          </span>
        </a>

        <a
          href="mailto:hello@vehi.systems"
          className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${
            scrolled
              ? 'bg-primary text-white hover:bg-primary-shade'
              : 'text-white border border-white/25 hover:bg-white/10 hover:border-white/40'
          }`}
        >
          Let's talk
        </a>
      </div>
    </nav>
  );
}
